import en from './en.json';
import fr from './fr.json';

export const readingsI18n = {
  fr,
  en,
};
